import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
    InputGroup, SideCancelBtn, SubmitBtn, ActionSection,
    ScrollableContent,
    Wrapper,
    FieldWrappers,
} from "../Styles/InputStyles";

const AddLocationModel = ({ addLocationLoading, addLocationMutate, setLocationModel, selectedData }) => {

    const initialValues = {
        latitude: selectedData?.latitude || "",
        longitude: selectedData?.longitude || "",
    };

    const validationSchema = Yup.object({
        latitude: Yup.string()
            .matches(/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/, "Invalid latitude")
            .required("Latitude is required"),
        longitude: Yup.string()
            .matches(/^[-+]?((1[0-7]\d)|(\d{1,2}))(\.\d+)?$/, "Invalid longitude")
            .required("Longitude is required"),
    });

    const handleSubmit = (values, { resetForm }) => {
        addLocationMutate({
            latitude: values.latitude,
            longitude: values.longitude,
            propId: selectedData?.id,
        });
        resetForm();
    };

    return (
        <Container>
            <Header>
                <h1 className="text-white text-lg font-medium">Location Co-ordinates</h1>
                <button onClick={() => setLocationModel(false)}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label>Latitude *</Label>
                                        <FieldWrappers>
                                            <Field name="latitude" autoComplete="off" />
                                        </FieldWrappers>
                                        <ErrorMessage name="latitude" component="div" className="text-red-500 text-sm" />
                                    </InputGroup>

                                    <InputGroup>
                                        <Label>Longitude *</Label>
                                        <FieldWrappers>
                                            <Field name="longitude" autoComplete="off" />
                                        </FieldWrappers>
                                        <ErrorMessage name="longitude" component="div" className="text-red-500 text-sm" />
                                    </InputGroup>

                                    <div className="text-sm text-gray-500">
                                        Note: To get accurate latitude and longitude, you can visit
                                        <a
                                            href="https://www.latlong.net/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 underline ml-1"
                                        >
                                            LatLong.net
                                        </a>
                                        and enter your address to fetch the coordinates.
                                    </div>
                                </Wrapper>
                            </ScrollableContent>

                            <ActionSection>
                                <SideCancelBtn type="button" onClick={() => setLocationModel(false)}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={addLocationLoading}>
                                    {addLocationLoading ? "Submiting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const FieldWrapper = tw.div`w-full`;
const Label = tw.label`text-sm text-gray-500 font-normal `;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;

export default AddLocationModel;
